import { createContext, useContext, useState } from "react";
import axios from 'axios';

const AuthContext = createContext(null)

export const useAuth = () => {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [error, setError] = useState(null)
  //const [isLoading, setIsLoading] = useState(true);
  const [allowedPaths, setAllowedPaths] = useState([])


  const login = async (payload) => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    try {
      const { data } = await axios.post('/api/login', payload, config);
      if (data?.error) {
        setError(data.error);
      } else {
        setUser(data);
      }
    } catch (e) {
      setError('Ошибка аутентификации!')
    }
  }

  const logout = async () => {
    try {
      await axios.post('/api/logout', {}, { withCredentials: true })
    } catch (error) {
      // Ignore logout errors
    }
    setUser(null)
    setError(null)
  }


  const value = { user, setUser, login, logout, allowedPaths, setAllowedPaths, error, setError }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider